import { render, staticRenderFns } from "./SupplierRequirementsConfirmation.view.vue?vue&type=template&id=32799db0&"
import script from "./SupplierRequirementsConfirmation.view.vue?vue&type=script&lang=js&"
export * from "./SupplierRequirementsConfirmation.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32799db0')) {
      api.createRecord('32799db0', component.options)
    } else {
      api.reload('32799db0', component.options)
    }
    module.hot.accept("./SupplierRequirementsConfirmation.view.vue?vue&type=template&id=32799db0&", function () {
      api.rerender('32799db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/contract/sign/partials/SupplierRequirementsConfirmation.view.vue"
export default component.exports